// Tour Data contains MGW urls
function isTourFullyProcessed(tourData) {
    return tourData?.spheres?.length > 0 && tourData.spheres[0].hasOwnProperty('mediaGatewayURL');
}

export {isTourFullyProcessed};
